import { motion } from 'framer-motion'
import {
  LogOut,
  Menu,
  Moon,
  Settings,
  Sun,
  User
} from 'lucide-react'
import { useTheme } from '../contexts/ThemeContext'
import { Button } from './ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu'

const Header = ({ user, onToggleSidebar, sidebarOpen, onLogout }) => {
  const { isDarkMode, toggleTheme } = useTheme()

  const handleLogout = () => {
    if (onLogout) {
      onLogout()
    }
  }

  // 獲取用戶角色顯示名稱
  const getUserRoleDisplay = (role) => {
    const roleMap = {
      'super_admin': '超級管理員',
      'admin': '管理員',
      'developer': '開發人員',
      'senior_attorney': '資深專利律師',
      'attorney': '專利律師',
      'assistant': '助理',
      'user': '用戶'
    }
    return roleMap[role] || role
  }

  return (
    <motion.header
      className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700 h-16 flex items-center justify-between px-6 sticky top-0 z-50 transition-colors duration-200"
      initial={{ y: -64 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.3 }}
    >
      {/* 左側 - Logo 和選單按鈕 */}
      <div className="flex items-center space-x-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={onToggleSidebar}
          className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 lg:hidden transition-colors"
        >
          <Menu className="h-5 w-5 text-gray-600 dark:text-gray-300" />
        </Button>

        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-sm">IP</span>
          </div>
          <div className="hidden md:block">
            <h1 className="text-lg font-bold text-gray-900 dark:text-gray-100">
              智財權助理平台
            </h1>
            <p className="text-xs text-gray-500 dark:text-gray-400">AI Patent Assistant</p>
          </div>
        </div>
      </div>

      {/* 右側 - 功能按鈕和用戶選單 */}
      <div className="flex items-center space-x-3">
        {/* 主題切換 */}
        <Button
          variant="ghost"
          size="sm"
          onClick={toggleTheme}
          className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        >
          {isDarkMode ? (
            <Sun className="h-5 w-5 text-gray-600 dark:text-gray-300" />
          ) : (
            <Moon className="h-5 w-5 text-gray-600 dark:text-gray-300" />
          )}
        </Button>

        {/* 用戶選單 */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="flex items-center space-x-2 p-2 hover:bg-gray-100 dark:hover:bg-gray-700">
              <div className="w-8 h-8 bg-gradient-to-br from-green-400 to-blue-500 rounded-full flex items-center justify-center">
                <span className="text-white font-medium text-sm">
                  {user.username.charAt(0).toUpperCase()}
                </span>
              </div>
              <div className="hidden md:block text-left">
                <p className="text-sm font-medium text-gray-900 dark:text-white">{user.username}</p>
                <p className="text-xs text-gray-500 dark:text-gray-300 font-medium">{getUserRoleDisplay(user.role)}</p>
              </div>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel>我的帳戶</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem className="flex items-center space-x-2">
              <User className="h-4 w-4" />
              <span>個人資料</span>
            </DropdownMenuItem>
            <DropdownMenuItem className="flex items-center space-x-2">
              <Settings className="h-4 w-4" />
              <span>系統設定</span>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="flex items-center space-x-2 text-red-600 cursor-pointer"
              onClick={handleLogout}
            >
              <LogOut className="h-4 w-4" />
              <span>登出</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </motion.header>
  )
}

export default Header